import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-reservacion',
  templateUrl: './reservacion.component.html',
  styleUrls: ['./reservacion.component.scss'],
})
export class ReservacionComponent implements OnInit {
  @Input() isHistorial: boolean = false;
  @Input() pagarTexto: string = 'Voy a pagar';
  @Input() recibiTexto: string = 'Voy a recibir';

  @Input() cotizacion: any;
  @Input() typoCard: string = 'normal';

  constructor() {}

  ngOnInit(): void {}
}
